export default __webpack_public_path__ + "static/media/apple-touch-icon.1f3a3af9.png";